export default "__VITE_ASSET__b85d1ed0__"